import { RefObject, useMemo } from 'react';
import EmailEditor, { EditorRef } from 'react-email-editor';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useUnlayerUserSignature } from '../../../../../../hooks/Marketing';
import { EDITOR_HEIGHT } from './unlayerDesign';

interface UnlayerEditorPaneProps {
  editorRef: RefObject<EditorRef | null>;
  visible: boolean;
  ready: boolean;
  onReady: () => void;
}

function UnlayerEditorPane({ editorRef, visible, ready, onReady }: UnlayerEditorPaneProps) {
  const { user, loading } = useUnlayerUserSignature();

  const options = useMemo(() => ({
    projectId: 288607,
    // Built-in French is 'fr'. A 'fr-FR' key under `translations` would make Unlayer treat 'fr-FR' as a
    // custom locale: only the overridden label would be French, every other string back to English.
    locale: 'fr',
    appearance: { theme: 'light' as const },
    translations: { fr: { 'labels.merge_tags': 'Codes & Champs' } },
    ...(user ? { user } : {}),
  }), [user]);

  return (
    <Box sx={{ display: visible ? 'block' : 'none', position: 'relative', height: EDITOR_HEIGHT, border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      {!ready && (
        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, zIndex: 1, backgroundColor: 'grey.50' }}>
          <CircularProgress size={32} sx={{ color: 'primary.main' }} />
          <Typography variant="caption" color="text.secondary">
            Chargement de l&apos;éditeur…
          </Typography>
        </Box>
      )}
      {!loading && (
        <EmailEditor
          ref={editorRef}
          onReady={onReady}
          options={options}
          style={{ height: EDITOR_HEIGHT, opacity: ready ? 1 : 0 }}
        />
      )}
    </Box>
  );
}

export default UnlayerEditorPane;
